define([
	"dojo/_base/declare",
	"./ProductSwitchboard"
], function(declare, ProductSwitchboard) {

	return declare(ProductSwitchboard, {
		idViewProperty: "bomActiveSizes",
		productSizeName: "bomSize1Name",
		productStoreName: "bomSize1Store"
	});
});
